/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Sweet_DetrainingInputs */

const en_coach_sweet_detraining = /** @type {(inputs: Coach_Sweet_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your fitness is starting to decline because training has been too light recently. Your body has fully recovered and is ready for more stimulus. Consider gradually increasing your training volume to get back on track.`)
};

const de_coach_sweet_detraining = /** @type {(inputs: Coach_Sweet_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Fitness bröckelt, weil das Training zuletzt zu leicht war. Dein Körper ist vollständig erholt und bereit für mehr. Versuch, den Umfang Schritt für Schritt wieder hochzufahren.`)
};

/**
* | output |
* | --- |
* | "Your fitness is starting to decline because training has been too light recently. Your body has fully recovered and is ready for more stimulus. Consider grad..." |
*
* @param {Coach_Sweet_DetrainingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_sweet_detraining = /** @type {((inputs?: Coach_Sweet_DetrainingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Sweet_DetrainingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_sweet_detraining(inputs)
	return de_coach_sweet_detraining(inputs)
});